import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import {
  PDA1121_R01Dto,
  PDA1121_R01SearchParams,
  RequiredItem,
} from "src/containers/PDA/PDA1121_R01/PDA1121_R01Dto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1121_R01`;

/** 공정지시 목록 (검색) */
export const searchWorkOrders = (params?: PDA1121_R01SearchParams) =>
  getData<ResponseDto<PDA1121_R01Dto[]>>(`${baseUrl}/search`, { params });

/** 공정지시 목록 (새로고침) */
export const refetchWorkOrders = (params?: PDA1121_R01SearchParams) =>
  getData<ResponseDto<PDA1121_R01Dto[]>>(`${baseUrl}/refetch`, { params });

/** 필요자재 목록 + 필요량 */
export const getRequiredItems = (productWorkNo: string) =>
  getData<ResponseDto<RequiredItem[]>>(`${baseUrl}/materials/${productWorkNo}`);
